
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class MyWorkspaceFinanceState extends BaseYcState {
  readonly mostRecentPayments: any;
  readonly verifyDonationsTotal: number;
  readonly volunteerHoursUnverified: number;
}
